/* =========================================================
   GLAM GRACE – Willkommens-Popup, Hinweis und Vorschlaege im Warenkorb
   ========================================================= */
(function () {
  'use strict';

  var EN = /^en/i.test(document.documentElement.lang || '');
  function T(de, en) { return EN ? en : de; }

  var KEY = 'gg-waitlist-drop01';
  var REMIND_AFTER = 14 * 24 * 60 * 60 * 1000;
  var popup = null;
  var lastFocus = null;

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  /* ---------- Popup ---------- */
  function openPopup() {
    if (!popup || popup.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('gg-popup-lock');
    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    var target = popup.querySelector('.gg-popup__input, .gg-popup__button');
    if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, 450);
  }

  function closePopup() {
    if (!popup || !popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('gg-popup-lock');
    var state = readState();
    if (!state.done) {
      state.closed = Date.now();
      writeState(state);
    }
    setTimeout(function () { popup.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function initPopup() {
    popup = document.getElementById('GGPopup');
    if (!popup || popup.dataset.ggReady) return;
    popup.dataset.ggReady = '1';

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-gg-popup-close]')) {
        event.preventDefault();
        closePopup();
      }
    });

    var state = readState();
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    if (popup.querySelector('[data-gg-popup-success]') && posted) {
      state.done = true;
      writeState(state);
      openPopup();
      return;
    }
    if (popup.querySelector('[data-gg-popup-error]') && window.location.hash === '#GGPopupForm') {
      openPopup();
      return;
    }

    if (popup.dataset.enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (state.done) return;
    if (state.closed && Date.now() - state.closed < REMIND_AFTER) return;

    var delay = parseInt(popup.dataset.delay, 10) || 4;
    setTimeout(openPopup, delay * 1000);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-gg-popup-open]');
    if (!trigger) return;
    event.preventDefault();
    popup = document.getElementById('GGPopup');
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
    setTimeout(openPopup, 250);
  });

  /* Im Theme-Editor: Popup zeigen, solange der Abschnitt ausgewaehlt ist */
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('#GGPopup')) {
      popup = document.getElementById('GGPopup');
      openPopup();
    }
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target.querySelector('#GGPopup')) closePopup();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('#GGPopup')) {
      popup = null;
      initPopup();
    }
  });

  /* ---------- Warenkorb: Hinweis und kleine Produktvorschlaege ---------- */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var productsPromise = null;
  var placing = false;
  var BAG_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M4.5 9h11l-.8 11.5H5.3z" fill="none" stroke="currentColor" stroke-width="1.2"/>' +
    '<path d="M7.5 9V7.5a2.5 2.5 0 0 1 5 0V9" fill="none" stroke="currentColor" stroke-width="1.2"/>' +
    '<path d="M19.5 3v6M16.5 6h6" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';

  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = String(str || '');
    return t.value.replace(/<[^>]*>/g, '');
  }

  function formatNumber(num, decimals, thousands, decimal) {
    var parts = num.toFixed(decimals).split('.');
    var int = parts[0], out = '';
    while (int.length > 3) { out = thousands + int.slice(-3) + out; int = int.slice(0, -3); }
    parts[0] = int + out;
    return parts.join(decimal);
  }

  function formatMoney(cents) {
    var fmt = decode(window.ggMoneyFormat || '€{{amount_with_comma_separator}}');
    var n = Number(cents || 0) / 100;
    return fmt.replace(/[{][{] *([a-z_]+) *[}][}]/, function (_, key) {
      if (key === 'amount') return formatNumber(n, 2, ',', '.');
      if (key === 'amount_no_decimals') return formatNumber(n, 0, ',', '.');
      if (key === 'amount_no_decimals_with_comma_separator') return formatNumber(n, 0, '.', ',');
      return formatNumber(n, 2, '.', ',');
    });
  }

  function sizedImage(src, width) {
    var url = String(src || '');
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function loadProducts() {
    if (!productsPromise) {
      productsPromise = fetch(ROOT + 'collections/all/products.json?limit=16')
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { productsPromise = null; return []; });
    }
    return productsPromise;
  }

  function buildRecs(products) {
    var list = el('div', 'gg-recs');
    list.setAttribute('aria-label', T('Produktvorschläge', 'Product suggestions'));
    products.forEach(function (p) {
      var url = ROOT + 'products/' + p.handle;
      var card = el('div', 'gg-rec2');
      var visual = el('div', 'gg-rec2__visual');
      var media = el('a', 'gg-rec2__media');
      media.href = url;
      if (p.images && p.images[0]) {
        var img = document.createElement('img');
        img.src = sizedImage(p.images[0].src, 300);
        img.alt = p.title;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      visual.appendChild(media);

      var add = el('button', 'gg-rec2__add');
      add.type = 'button';
      add.innerHTML = BAG_PLUS;
      add.setAttribute('aria-label', T(p.title + ' in den Warenkorb legen', 'Add ' + p.title + ' to cart'));
      if (p.variants.length > 1) {
        add.setAttribute('data-mode', 'sizes');
        add.setAttribute('aria-expanded', 'false');
        var sizes = el('div', 'gg-rec2__sizes');
        sizes.hidden = true;
        p.variants.forEach(function (v) {
          var size = el('button', 'gg-rec2__size', v.title);
          size.type = 'button';
          size.setAttribute('data-variant', v.id);
          size.setAttribute('aria-label', T('Größe ' + v.title + ' in den Warenkorb legen', 'Add size ' + v.title + ' to cart'));
          if (!v.available) size.disabled = true;
          sizes.appendChild(size);
        });
        visual.appendChild(sizes);
      } else if (p.variants[0] && p.variants[0].available) {
        add.setAttribute('data-variant', p.variants[0].id);
      } else {
        add.disabled = true;
      }
      visual.appendChild(add);
      card.appendChild(visual);

      var name = el('a', 'gg-rec2__name', p.title);
      name.href = url;
      card.appendChild(name);
      var cents = Math.min.apply(null, p.variants.map(function (v) { return Math.round(parseFloat(v.price) * 100); }));
      card.appendChild(el('p', 'gg-rec2__price', formatMoney(cents)));
      list.appendChild(card);
    });
    return list;
  }

  function addToCart(variantId, button) {
    var drawer = document.querySelector('cart-drawer');
    button.classList.add('is-loading');
    button.disabled = true;
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'error');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        else window.location.href = ROOT + 'cart';
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
        button.classList.add('is-error');
        setTimeout(function () { button.classList.remove('is-error'); }, 1600);
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('.gg-rec2__add, .gg-rec2__size');
    if (!target) return;
    event.preventDefault();
    if (target.classList.contains('gg-rec2__size')) {
      addToCart(target.getAttribute('data-variant'), target);
      return;
    }
    if (target.getAttribute('data-mode') === 'sizes') {
      var sizes = target.parentNode.querySelector('.gg-rec2__sizes');
      var open = sizes.hidden;
      document.querySelectorAll('.gg-rec2__sizes').forEach(function (s) { s.hidden = true; });
      document.querySelectorAll('.gg-rec2__add[data-mode]').forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
      sizes.hidden = !open;
      target.classList.toggle('is-open', open);
      target.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    addToCart(target.getAttribute('data-variant'), target);
  });

  function buildCartNote(code) {
    var wrap = el('div', 'gg-cartnote');
    var more = el('div', 'gg-cartnote__more');
    more.appendChild(el('p', 'gg-cartnote__text', T('Möchtest du noch etwas hinzufügen?', 'Would you like to add something else?')));
    var link = el('a', 'gg-cartnote__link', T('Alle ansehen', 'View all'));
    link.href = ROOT + 'collections/all';
    more.appendChild(link);
    wrap.appendChild(more);

    if (!code) {
      return wrap;
    }
    if (readState().done) {
      var info = el('p', 'gg-cartnote__promo gg-cartnote__promo--code');
      info.appendChild(document.createTextNode(T('Dein Code für 10 %: ', 'Your 10 % code: ')));
      info.appendChild(el('strong', '', code));
      info.appendChild(document.createTextNode(T(' – einfach an der Kasse eingeben.', ' – just enter it at checkout.')));
      wrap.appendChild(info);
    } else {
      var btn = el('button', 'gg-cartnote__promo', T('10 % auf deine erste Bestellung – jetzt Newsletter abonnieren', '10 % off your first order – subscribe to our newsletter'));
      btn.type = 'button';
      btn.setAttribute('data-gg-popup-open', '');
      wrap.appendChild(btn);
    }
    return wrap;
  }

  function fillRecs() {
    if (placing) return;
    placing = true;
    Promise.all([
      loadProducts(),
      fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
    ]).then(function (res) {
      placing = false;
      var note = document.querySelector('#CartDrawer .gg-cartnote');
      if (!note || note.querySelector('.gg-recs')) return;
      var inCart = (res[1].items || []).map(function (i) { return i.product_id; });
      var available = res[0].filter(function (p) {
        return p.variants.some(function (v) { return v.available; });
      });
      var picks = available.filter(function (p) { return inCart.indexOf(p.id) === -1; });
      if (!picks.length) picks = available;
      picks = picks.slice(0, 6);
      if (!picks.length) return;
      var more = note.querySelector('.gg-cartnote__more');
      more.insertAdjacentElement('afterend', buildRecs(picks));
    });
  }

  function placeCartNote() {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;
    var existing = inner.querySelector('.gg-cartnote');
    var footer = inner.querySelector('.drawer__footer');
    if (inner.classList.contains('is-empty') || !footer) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      var source = document.getElementById('GGPopup');
      var code = source ? source.dataset.code : '';
      existing = buildCartNote(code);
      footer.parentNode.insertBefore(existing, footer);
    }
    if (!existing.querySelector('.gg-recs')) fillRecs();
  }

  function watchCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.ggNote) return;
    drawer.dataset.ggNote = '1';
    new MutationObserver(placeCartNote).observe(drawer, { childList: true, subtree: true });
    placeCartNote();
  }

  function init() {
    initPopup();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();